import { useMemo } from "react";
import { create } from "qrcode";

const QUIET_ZONE_MODULES = 4;

export interface TotpQrMatrix {
  data: Uint8Array;
  size: number;
}

export function createTotpQrMatrix(provisioningUri: string): TotpQrMatrix {
  if (!provisioningUri.startsWith("otpauth://totp/")) {
    throw new Error("TOTP 注册 URI 无效");
  }
  const { modules } = create(provisioningUri, { errorCorrectionLevel: "M" });
  return {
    data: Uint8Array.from(modules.data),
    size: modules.size,
  };
}

export function TotpQrCode({ provisioningUri }: { provisioningUri: string }) {
  const matrix = useMemo(() => createTotpQrMatrix(provisioningUri), [provisioningUri]);
  const path = useMemo(() => matrixPath(matrix), [matrix]);
  const dimension = matrix.size + QUIET_ZONE_MODULES * 2;

  return (
    <svg
      aria-label="腾讯身份验证器 TOTP 注册二维码"
      className="totp-qr-code"
      role="img"
      shapeRendering="crispEdges"
      viewBox={`0 0 ${dimension} ${dimension}`}
    >
      <rect fill="#ffffff" height={dimension} width={dimension} />
      <path d={path} fill="currentColor" />
    </svg>
  );
}

function matrixPath(matrix: TotpQrMatrix): string {
  const commands: string[] = [];
  for (let row = 0; row < matrix.size; row += 1) {
    for (let column = 0; column < matrix.size; column += 1) {
      if (matrix.data[row * matrix.size + column]) {
        commands.push(`M${column + QUIET_ZONE_MODULES},${row + QUIET_ZONE_MODULES}h1v1h-1z`);
      }
    }
  }
  return commands.join("");
}
